const data = [
  {
    id: "cardlist1",
    title: "平權未來",
    cardinfo: [
      {
        site_name: 'equality_14',
        name: '蔡依林',
        title: '亞洲天后 用音樂挺平權',
      },
      {
        site_name: 'equality_2',
        name: '尹莘玲',
        title: '用專業 解救孩子的傷',
      },
      {
        site_name: 'equality_3',
        name: '郭水義',
        title: '賦能偏鄉童 築夢在地',
      },
      {
        site_name: 'equality_4',
        name: '王偉華',
        title: '為每個孩子 創造選擇',
      },
      {
        site_name: 'equality_5',
        name: '林宜錚',
        title: '移工追夢 異鄉不孤單',
      },
      {
        site_name: 'equality_1',
        name: '陳彥翰',
        title: '台東孩子 能看見未來',
      },
      {
        site_name: 'equality_6',
        name: '方荷生',
        title: '讓食物銀行 遍地開花',
      },
      {
        site_name: 'equality_7',
        name: '陳凱翔',
        title: '為移工 留下美好回憶',
      },
      {
        site_name: 'equality_8',
        name: '林麗蟬',
        title: '為台灣 構築移民政策 ',
      },
      {
        site_name: 'equality_9',
        name: '陳秀雅',
        title: '性平教育 助聽障發聲',
      },
      {
        site_name: 'equality_10',
        name: '陳莉茵',
        title: '兒患罕病 挺身推改革',
      },
      {
        site_name: 'equality_11',
        name: '楊婕妤',
        title: '用大愛 擁抱每個靈魂',
      },
      {
        site_name: 'equality_12',
        name: '林綠紅',
        title: '受試者權益 應受保障',
      },
      {
        site_name: 'equality_13',
        name: '陳美如',
        title: '陪伴弱勢童 打造家園',
      },
    ]
  },
  {
    id: "cardlist2",
    title: "安居未來",
    cardinfo: [
      {
        site_name: 'living_1',
        name: '蔣勳',
        title: '願台灣人 與自然共存',
      },
      {
        site_name: 'living_2',
        name: '杜瑛秋',
        title: '推動專法 終止性暴力',
      },
      {
        site_name: 'living_3',
        name: '辜仲諒',
        title: '解決毒害 從教育開始 ',
      },
      {
        site_name: 'living_4',
        name: '江元凱',
        title: '伴更生少年 咖啡築夢',
      },
      {
        site_name: 'living_7',
        name: '呂秉怡',
        title: '健全租屋市場 人人安居',
      },
      {
        site_name: 'living_5',
        name: '陳昱芳',
        title: '杜絕酒駕  悲痛變力量',
      },
      {
        site_name: 'living_6',
        name: '許家誠',
        title: '用掌中溫度 溫暖浪子',
      },
    ]
  },
  {
    id: "cardlist3",
    title: "高齡未來",
    cardinfo: [
      {
        site_name: 'aging_1',
        name: '余尚儒',
        title: '熟悉的家 是最好病房',
      },
      {
        site_name: 'aging_2',
        name: '廖振益',
        title: '偏鄉長輩 能老有所安',
      },
      {
        site_name: 'aging_7',
        name: '潘人豪',
        title: '科技創新 助偏鄉長者',
      },
      {
        site_name: 'aging_3',
        name: '楊基寬',
        title: '打破年齡高牆 翻轉職場',
      },
      {
        site_name: 'aging_4',
        name: '井琪',
        title: '5G科技 為醫療注暖流',
      },
      {
        site_name: 'aging_5',
        name: '程世嘉',
        title: '助長輩 脫離數位弱勢',
      },
      {
        site_name: 'aging_6',
        name: '劉毓秀',
        title: '為少子化危機 提解方',
      },

      {
        site_name: 'aging_8',
        name: '失智‧時空記憶的旅人',
        title: '讓失智照顧者 不孤單',
      },
      {
        site_name: 'aging_9',
        name: '許金川',
        title: '消滅肝病 全民一起來',
      },
      {
        site_name: 'aging_10',
        name: '趙可式',
        title: '安寧善終  好好說再見',
      },
    ]
  },
  {
    id: "cardlist4",
    title: "永續未來",
    cardinfo: [
      {
        site_name: 'sustainability_1',
        name: '吳書原',
        title: '讓台灣物種 立足世界',
      },
      {
        site_name: 'sustainability_2',
        name: '林哲安',
        title: '友善耕作 還鳥一個家',
      },
      {
        site_name: 'sustainability_3',
        name: '鄭崇華',
        title: '守護環境 推廣永續理念',
      },
      {
        site_name: 'sustainability_4',
        name: '張介冠',
        title: '鑄字職人 復興老產業',
      },
      {
        site_name: 'sustainability_5',
        name: '葉榮廷',
        title: '減少食物浪費 友善地球',
      },
      {
        site_name: 'sustainability_22',
        name: '劉德音',
        title: '年輕人 要敢於夢想',
      },
      {
        site_name: 'sustainability_6',
        name: '宋文生',
        title: '守護山林 為台灣種樹',
      },
      {
        site_name: 'sustainability_7',
        name: '黃美秀',
        title: '深入山區 為黑熊發聲',
      },
      {
        site_name: 'sustainability_9',
        name: '沙力浪',
        title: '讓原民領域 永續經營',
      },
      {
        site_name: 'sustainability_8',
        name: '張卉君',
        title: '海洋教育 讓海不受害',
      },
      {
        site_name: 'sustainability_23',
        name: '抗疫醫護',
        title: '守護台灣 醫護齊心抗疫',
      },
      {
        site_name: 'sustainability_21',
        name: '江慧儀、孟磊',
        title: '荒野中 雙手蓋泥巴屋',
      },
      {
        site_name: 'sustainability_10',
        name: '許晃雄',
        title: '氣候危機 再拖來不及',
      },
      {
        site_name: 'sustainability_11',
        name: '陳思穎',
        title: '保衛海洋 向海廢宣戰',
      },
      {
        site_name: 'sustainability_12',
        name: '鄭涵睿',
        title: '永續消費 讓環境更好',
      },
      {
        site_name: 'sustainability_13',
        name: '歐陽藹寧',
        title: '搭一座橋 推循環經濟',
      },
      {
        site_name: 'sustainability_14',
        name: '黃國良',
        title: '帶無毒水產 走向國際',
      },
      {
        site_name: 'sustainability_15',
        name: '陳人祥',
        title: '貓中途 為浪貓找個家',
      },
      {
        site_name: 'sustainability_16',
        name: '廖桂賢',
        title: '河川復育 還地給自然',
      },
      {
        site_name: 'sustainability_17',
        name: '吳碧霜',
        title: '食農發電 從自己做起',
      },
      {
        site_name: 'sustainability_18',
        name: '郭中端',
        title: '護土親水 讓台灣變美',
      },
      {
        site_name: 'sustainability_19',
        name: '林志龍',
        title: '六萬杯子 無限環保力',
      },
      {
        site_name: 'sustainability_20',
        name: '楊儒門',
        title: '深入農村 推友善耕作',
      },
    ]
  },
  {
    id: "cardlist5",
    title: "經濟創新",
    cardinfo: [
      {
        site_name: 'economy_1',
        name: '林以涵',
        title: '社企工作 不再是犧牲',
      },
      {
        site_name: 'economy_2',
        name: '郭家佑',
        title: '為台灣 建立人脈存摺',
      },
      {
        site_name: 'economy_3',
        name: '李長庚',
        title: '金控巨頭 推數位轉型',
      },
      {
        site_name: 'economy_4',
        name: '吳庭安',
        title: '循環經濟 創造新商機',
      }
    ]
  },
  {
    id: "cardlist6",
    title: "教育創新",
    cardinfo: [
      {
        site_name: 'education_1',
        name: '李吉仁',
        title: '好老師 不分正式代理',
      },
      {
        site_name: 'education_2',
        name: '劉安婷',
        title: '讓優質人才 跨域流動',
      },
      {
        site_name: 'education_3',
        name: '陳慕天',
        title: '讓台灣教育 更有美感',
      },
      {
        site_name: 'education_4',
        name: '林隆奮',
        title: '向下扎根 培養軟體人才',
      },
      {
        site_name: 'education_5',
        name: '葉丙成',
        title: '為台灣 培養思辨文化',
      },
      {
        site_name: 'education_6',
        name: '陳清圳',
        title: '用實驗教育 翻轉偏鄉',
      },
    ]
  },
  {
    id: "cardlist7",
    title: "在地創新",
    cardinfo: [
      {
        site_name: 'region_1',
        name: '江振誠',
        title: '國際名廚 尋覓台灣味 ',
      },
      {
        site_name: 'region_2',
        name: '林峻丞',
        title: '用行動 扭轉故鄉土地',
      },
      {
        site_name: 'region_3',
        name: '何培鈞',
        title: '讓地方創生 接軌亞洲',
      },
      {
        site_name: 'region_4',
        name: '王嘉納',
        title: '發展在地 讓孩子留鄉',
      },
      {
        site_name: 'region_5',
        name: '謝英俊',
        title: '助原民重建 一待二十年',
      },
      {
        site_name: 'region_6',
        name: '吳茂成',
        title: '讓在地記憶 永續流傳',
      },
    ]
  },
]

export default data
